<template>
  <div id="msg">
    <Center></Center>
  </div>
</template>

<script>
import Center from "./components/center";
export default {
  name: "index",
  components: {
    Center,
  },
};
</script>

<style lang="scss" scoped>
#msg {
  //background: yellow;
}
</style>
